import React from "react";
import PersonIcon from "@mui/icons-material/Person";
import GroupsIcon from "@mui/icons-material/Groups";
import WhatshotIcon from "@mui/icons-material/Whatshot";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";

export interface ActiveProductsParentCategory {
  parentLabel: string;
  children: readonly string[];
  color: string;
  Icon: React.ElementType;
}

export const ACTIVE_PRODUCTS_PARENT_CATEGORIES: ActiveProductsParentCategory[] =
  [
    {
      parentLabel: "Intruder",
      children: ["Intruder", "Vehicle", "Bike"],
      color: "#FF8400",
      Icon: PersonIcon,
    },
    {
      parentLabel: "Crowd",
      children: ["Crowd"],
      color: "#2196F3",
      Icon: GroupsIcon,
    },
    {
      parentLabel: "Fire",
      children: ["Fire", "Smoke"],
      color: "#F44336",
      Icon: WhatshotIcon,
    },
    {
      parentLabel: "Non-UPS Vehicle ID",
      children: ["Non-UPS"],
      color: "#03A9F4",
      Icon: DirectionsCarIcon,
    },
    {
      parentLabel: "Vehicle ID",
      children: [
        "Amazon",
        "DHL",
        "Fedex",
        "School Bus",
        "UPS",
        "USPS",
        "Fire Truck",
      ],
      color: "#4CAF50",
      Icon: LocalShippingIcon,
    },
  ];
